import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMap = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.0001 13.7578C14.2061 13.7578 16.0001 11.9638 16.0001 9.75781C16.0001 7.55181 14.2061 5.75781 12.0001 5.75781C9.79406 5.75781 8.00006 7.55181 8.00006 9.75781C8.00006 11.9638 9.79406 13.7578 12.0001 13.7578ZM12.0001 7.75781C13.1031 7.75781 14.0001 8.65481 14.0001 9.75781C14.0001 10.8608 13.1031 11.7578 12.0001 11.7578C10.8971 11.7578 10.0001 10.8608 10.0001 9.75781C10.0001 8.65481 10.8971 7.75781 12.0001 7.75781Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.4201 21.5718C11.5893 21.6927 11.7921 21.7577 12.0001 21.7577C12.2081 21.7577 12.4108 21.6927 12.5801 21.5718C12.8841 21.3568 20.0291 16.1978 20.0001 9.75781C20.0001 5.34681 16.4111 1.75781 12.0001 1.75781C7.58909 1.75781 4.00009 5.34681 4.00009 9.75281C3.97109 16.1978 11.1161 21.3568 11.4201 21.5718ZM12.0001 3.75781C15.3091 3.75781 18.0001 6.44881 18.0001 9.76281C18.0211 14.2008 13.6121 18.1858 12.0001 19.4928C10.3891 18.1848 5.97909 14.1988 6.00009 9.75781C6.00009 6.44881 8.69109 3.75781 12.0001 3.75781Z",
		fill: "currentColor"
	})]
});
export default SvgMap;
